export const canMultiSelect = (flowPermissions, flow, userId, enabledFeatures) =>
    flow &&
    (flowPermissions.canDelete ||
        !flow.IsLocked ||
        (flowPermissions.canCalculate && enabledFeatures.includes("flow-execute")));
